export const WALLET_MODAL = 'WALLET_MODAL';
export const EDIT_AUTHOR_NAME_MODAL = 'EDIT_AUTHOR_NAME_MODAL';
